import { Provider } from "react-redux";
import "./App.css";
import "./style/fit-table.css";
import AppRoutes from "./routes/AppRoutes";
import { store } from "./redux/store/store";
import { initSocket } from "./utils/socket";

initSocket();

function App() {
  return (
    <>
      <Provider store={store}>
        <AppRoutes />
      </Provider>
    </>
  );
}

export default App;
